import { apiClient } from "./ApiClient";

export const fetchTopUpPackages = async ({ iccid, currency = "EUR", offset = 0, count = 50, token }) => {
  try {
    const response = await apiClient.get("/topup/", {
      params: { iccid, currency, offset, count },
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  } catch (error) {
    console.error("Fetch Top-Up error:", error);
    throw error;
  }
};

export const purchaseTopUp = async ({ iccid, walletId, packageId, packageCode }) => {
  try {
    const response = await apiClient.post("/topup/", null, {
      params: {
        iccid: iccid,
        wallet_id: walletId,
        package_id: packageId,
        package_code: packageCode,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Top-Up purchase error:", error);
    throw error;
  }
};
